export default __webpack_public_path__ + "static/media/cvod-pg.64237ff0.svg";